const INITIAL_STATE = {
  error: null,
  loading: null,
  data: [],
};

const Serials = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SERIALS_REQUEST":
      return { loading: true, error: false, data: [] };
    case "SERIALS_ERROR":
      return { loading: false, error: true, data: [] };
    case "SERIALS_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "SERIALS_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default Serials;
